import * as React from 'react'

import { Box, ColumnSplit, Text } from '@factorialco/deprecated-design-system'

import PanesHeader from 'modules/core/components/PanesHeader'
import i18n from 'modules/core/lib/i18n'

import type Field from 'modules/custom_resources/store/models/customResources/Field'

interface Props {
  field: Field
}

const RatingSettings = ({ field }: Props) => (
  <ColumnSplit colored={false}>
    <PanesHeader
      description={i18n.t('app_store_v2.apps.competencies_custom_table.settings_range.description')}
      illustration="input-field"
      line={false}
      title={i18n.t('app_store_v2.apps.competencies_custom_table.settings_range.title')}
    />
    <Box>
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
      >
        <Box
          background="grey000White"
          gap="s8"
          padding="s24"
          borderRadius={{
            all: 'abs008',
          }}
          border={{
            bottom: {
              width: 's1',
              color: 'grey400',
              style: 'solid',
            },
          }}
        >
          <Text.Normal weight="semibold">
            {i18n.t('app_store_v2.apps.competencies_custom_table.settings_range.box.title')}
          </Text.Normal>
          <Text.Normal>
            {i18n.t('app_store_v2.apps.competencies_custom_table.settings_range.box.description', {
              min_value: field.attributes.min_value,
              max_value: field.attributes.max_value,
            })}
          </Text.Normal>
        </Box>
        <Box padding="s24">
          <Text.Normal>
            {i18n.t('app_store_v2.apps.competencies_custom_table.settings_range.box.explanation')}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  </ColumnSplit>
)

export default RatingSettings
